// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#5a50d8"};